import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportAttendanceToExcel = ({ employee, selectedMonth, summary, attendanceList }) => {
    const wb = XLSX.utils.book_new();

    // 1. Summary Sheet
    const summaryData = [
        ["Employee Code", employee?.code || "-"],
        ["Employee Name", employee?.name || "-"],
        ["Month", selectedMonth],
        ["Present Days", summary?.present_days || 0],
        ["Absent Days", summary?.absent_days || 0],
        ["Leave Days", summary?.leave_days || 0],
        ["Half Day Leaves", summary?.half_day_leaves || 0],
        ["Hour Permission", summary?.hour_permission || 0],
    ];
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    XLSX.utils.book_append_sheet(wb, summarySheet, "Summary");

    // 2. Attendance Table Sheet
    const tableData = [
        ["Date", "Status", "Check-In-Date", "Check-In-Time", "Check-Out-Date", "Check-Out-Time"],
        ...attendanceList.map(row => [
            formatDate(row.att_date),
            row.status || "-",
            formatDate(row.check_in_date),
            cleanTime(row.check_in_time),
            formatDate(row.check_out_date),
            cleanTime(row.check_out_time),
        ]),
    ];
    const attendanceSheet = XLSX.utils.aoa_to_sheet(tableData);
    XLSX.utils.book_append_sheet(wb, attendanceSheet, "Attendance");

    // Export to file
    const monthName = selectedMonth.replace("-", "_");
    const fileName = `Attendance_Report_${employee?.code}_${monthName}.xlsx`;
    XLSX.writeFile(wb, fileName);
};

const isInvalid = (val) =>
    !val || val.startsWith('0001-01-01');

const formatDate = (val) => {
    if (isInvalid(val)) return "-";
    const d = new Date(val);
    return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    }).replace(/ /g, "-");
};

const cleanTime = (time) => {
    if (!time || time.startsWith('0001-01-01')) return "-";
    return time;
};
